"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * DTO object for page of edit settings
 * This object contains all settings for one zone for better handling with data
 *
 * @author RV
 */


var SettingsDetailDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SettingsDetailDTO, _DomainObject_1$Domai);

  /**
   *
   * @param zoneId
   * @param settings List of three settings by price sensitivity
   */
  function SettingsDetailDTO(zoneId, settings) {
    var _this;

    _classCallCheck(this, SettingsDetailDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SettingsDetailDTO).call(this));
    _this.zoneId = zoneId;
    _this.settings = settings;
    return _this;
  }

  return SettingsDetailDTO;
}(DomainObject_1.DomainObject);

exports.SettingsDetailDTO = SettingsDetailDTO;